export const mergeSets = <T>(sets: Array<Set<T>>): Set<T> => {
  const result = new Set<T>();
  sets.forEach((set) => set.forEach((item) => result.add(item)));
  return result;
};
